import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  backgroundCheck: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'background-check' }),
}

export { paths }
